import React from 'react';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { GetCacheKey,isContainAlphabet } from '../../services/common/utils';
import { redirecturl } from '../../services/common/redirect';
import Loadingcomponent from '../loader/loadingcomponent';
import { getImgSrc } from '../../services/common/CommonUtils';
import { useSelector } from 'react-redux';

const Banner = ({ psmItem }) => {
  const navigate = useNavigate();
  const rnuserdetails = useSelector(
    (state) => state?.userdata?.value?.rnuserdetails
  );
  let imagePath = ''
  let redirectUrl = ''

  const {
    data: { data } = {},
    isLoading,
    isFetching,
  } = useQuery(
    [
      GetCacheKey(psmItem?.uniqueid),
      psmItem?.method,
      JSON.parse(psmItem?.sourceid),
      {},
    ],
    {
      retry: false,
      retryOnMount: false,
      cacheTime: 300000,
      staleTime: 300000,
    }
  );

  const handleRedirect = () => {
    if (redirectUrl === 'roamingviewall') {
      redirecturl('roaminghome', navigate);
    } else if (redirectUrl !== 'roamingviewall') {
      return redirecturl(redirectUrl, navigate);
    } else {
      return
    }
  };

  if (isLoading || isFetching) {
    return <Loadingcomponent />;
  }

  if (data?.response && data?.response?.length > 0) {
    if (data?.response[0]?.banners && data?.response[0]?.banners?.length > 0) {
      imagePath = data?.response[0]?.banners[0]?.path;
      redirectUrl = data?.response[0]?.banners[0]?.url;
    }
  }

    //  for test
    //  let name4 = '';
    //  let name1 = 'امتحان'; // Done
    //  let name5 = 'الاسم الأول' // Done
    //  let name3 = 'test'; // Done 
    //  let name31 = 'test new'; // Done
    //  let name2 = 'test امتحان'; // Done 

  let title = psmItem?.elementmeta?.title;
  title = title?.replace('!NICKNAME!', (rnuserdetails?.nickname ? `${rnuserdetails?.nickname}` : ''));

  return (
    <div className='pse_sm' id='noViewUsage'>
 <div className="flex-column height_100 align-item-center mt-5">
      <div className="com-wl w-100 pb-5">
        {
          rnuserdetails?.nickname && (
            <div className='primary_14 text-center mb-3 font-bold'>{title}</div>
          )
        }
        {
          imagePath && (
            <img src={getImgSrc(imagePath, true)} className="w-100 pointer" onClick={handleRedirect} />
          )
        }
      </div>
    </div>
    </div>
   
  );
};

export default Banner;
